import { HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IS_STANDALONE, ROUTERS } from '../../data';
import { CustomNavLink } from './CustomNavLink';

export const StackToStaticPages = (props: { [key: string]: any }) => {
  const { t } = useTranslation();
  const target = IS_STANDALONE ? '_self' : '_blank';

  return (
    <HStack spacing={5} alignItems='flex-end' mt={[5, 'initial']} color='whiteAlpha.600' fontSize='sm' {...props}>
      <CustomNavLink to={ROUTERS.STATIC.PRIVACY_POLICY} target={target}>
        {t('privacy.link')}
      </CustomNavLink>
      <CustomNavLink to={ROUTERS.STATIC.DISCLAIMER} target={target}>
        {t('disclaimer.link')}
      </CustomNavLink>
      <CustomNavLink to={ROUTERS.STATIC.RULES} target={target}>
        {t('rules.link')}
      </CustomNavLink>
    </HStack>
  );
};
